$(function () {
    if ($('form#PendingApplicationDetailsForm').length > 0) {


        $(".btnPrint").on('click', function () {
            //$('.printcont').printThis({
            //    debug: false,               // show the iframe for debugging
            //    importCSS: true,            // import page CSS
            //    importStyle: false,         // import style tags
            //    printContainer: true,       // grab outer container as well as the contents of the selector
            //    loadCSS: $("link.site").attr("href"),  // path to additional css file - us an array [] for multiple
            //    removeInline: false,        // remove all inline styles from print elements
            //    printDelay: 333,            // variable print delay
            //    copyTagClasses: true       // copy classes from the html & body tag
            //});
            window.setTimeout(function () {
                window.print();
            }, 333);
        });

        if ($("#IsResendEmailEnabled").val() == "True") {
            $(".displayResendEmail").prop("disabled", false).removeClass('d-none');
        }


        $("#WithdrawButton").click(function (e) {
            e.stopPropagation();
            e.preventDefault();

            if ($("form").valid()) {
                $("#approveModal").modal({
                    'backdrop': 'static'
                });
            }

            return false;
        });

        $(".btnConfirmWithdraw").on('click', function () {
            $("#IsWithdrawSelected").val(true);
            $("form").submit();
        });

        $("#EditButton").click(function () {
            $("#IsEditSelected").val(true);
            return true;
        });

        if ($("#IsWithdrawEnabled").val() == "True") {
            $("#WithdrawButton").prop("disabled", false).removeClass('d-none');
        }

        if ($("#IsEditEnabled").val() == "True") {
            $("#EditButton").prop("disabled", false).removeClass('d-none');
        }

        if ($("#IsSubmitEnabled").val() == "True") {
            $("#SubmitButton").prop("disabled", false).removeClass('d-none');
        }
        function navigate(prefix, lang) {
            if (prefix != "q") {
                //TODO url can be replace by a viewbag

                x = prefix + "/" + lang + "/" + 'admin/wageenhancement/facilitycontactlist/' + '@ViewContext.RouteData.Values["oper"].ToString()';
            }
            else {
                x = "/" + lang + "/" + 'admin/wageenhancement/facilitycontactlist/' + '@ViewContext.RouteData.Values["oper"].ToString()';
            }

            window.open(x);
            //Perform your navigation
        }

    } // if ($('form#PendingApplicationDetailsForm').length > 0)
}); // $(function () {